const faresPath = 'downloadable_resource/fares'

export default {
  /*
   * index() lista los ficheros descargables de tarifas
   */
  index(params) {
    return Vue.http.get(faresPath, {params}).then(response => response.data.data)
  }
}
